import React, { useContext, useState } from "react";
import {
  ModalButtonsContainer,
  ModalContext,
  TextButton,
} from "@SeemplicityDev/shared";
import CreditPacksList from "./CreditPacksList";
import CreditPackForm from "./CreditPackForm";
import { useAccountCreditPacks } from "../../../AnalystRuns/AnalystRunsApi";
import type { CreditPack } from "../../../AnalystRuns/types";
import type { AccountConfigSectionProps } from "../accountConfigTypes";

type CreditPacksView = "list" | "create" | "view";

const CreditPacksSection: React.FC<AccountConfigSectionProps> = ({
  accountUuid,
}) => {
  const { closeModal } = useContext(ModalContext);
  const [view, setView] = useState<CreditPacksView>("list");
  const [selectedPack, setSelectedPack] = useState<CreditPack | null>(null);

  const { data, isPending, isFetching, isError } =
    useAccountCreditPacks(accountUuid);

  const packs = data?.credit_packs ?? [];

  const isLoading = isPending || isFetching;

  const backToList = () => {
    setSelectedPack(null);
    setView("list");
  };

  const viewPack = (pack: CreditPack) => {
    setSelectedPack(pack);
    setView("view");
  };

  if (view === "create") {
    return (
      <CreditPackForm
        accountUuid={accountUuid}
        onCancel={backToList}
        onSuccess={backToList}
      />
    );
  }

  if (view === "view" && selectedPack) {
    return (
      <CreditPackForm
        accountUuid={accountUuid}
        pack={selectedPack}
        onCancel={backToList}
      />
    );
  }

  return (
    <>
      <CreditPacksList
        packs={packs}
        isLoading={isLoading}
        isError={isError}
        onSelectPack={viewPack}
      />
      <ModalButtonsContainer spaceBetween>
        <TextButton
          type="button"
          data-testid="credit-packs-close"
          label="Close"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            closeModal();
          }}
        />
        <TextButton
          type="button"
          buttonStyle="primary"
          data-testid="credit-packs-new"
          label="+ New Credit Pack"
          onClick={() => setView("create")}
        />
      </ModalButtonsContainer>
    </>
  );
};

export default CreditPacksSection;
